// src/utils/invoiceBalanceReview.js
//
// s0bcharge-bc5e9925 — S0b, display only (Marcus, 2026-10-14). The server leaves a `balanceReview`
// flag on an invoice when it pauses online card payment because the saved balance is missing or
// disagrees with the invoice's payments. The flag stays as history for Spatchy support, but the
// amber "Online card payment is paused" banner should only show while the problem is still there:
// once the figures agree again (for example after a manual payment, which rewrites them), the
// server takes card payments again, so the banner must go too.
//
// Same rule and tolerance as functions/utils/invoiceChargeable.js (assessInvoiceCharge): the saved
// balance is missing, or differs from computeInvoiceBalance by more than one cent.
// src/utils/invoiceBalanceReview.test.js checks both agree.

import { computeInvoiceBalance } from './invoiceBalance';

const cents = (x) => Math.round((Number(x) || 0) * 100);

/** True when the saved balance is missing or more than $0.01 off the payments. */
export function balanceFiguresDisagree(invoice) {
    const v = invoice ? invoice.balanceDue : undefined;
    if (v === undefined || v === null || v === '' || !Number.isFinite(Number(v))) return true;
    return Math.abs(cents(v) - cents(computeInvoiceBalance(invoice).balanceDue)) > 1;
}

/** Show the "paused" banner: the invoice was flagged AND its figures still disagree. */
export function isBalanceReviewActive(invoice) {
    return !!(invoice && invoice.balanceReview) && balanceFiguresDisagree(invoice);
}
